module.exports = __webpack_public_path__ + "static/img/14000017.5b1dd728.png";